import PropertySaleSheetList from "containers/property/PropertySaleSheetList";
import { Modal } from "react-bootstrap";

function PropertySaleSheetModal({
    isAuthenticated,
    user,
    updateTableState,
    filter,
    saveForm,
    data,
    saveRecord,
    deleteRecord,
    salesheetid,
    validateRelatedRecord,
    onClose,
    show,
}) {

    return (
        <Modal show={show} onHide={onClose} dialogClassName="modal-90w">
            <Modal.Header closeButton>
                <Modal.Title>Property Sale Sheets</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Only the Cityscope Reference can be edited. The remaining fields are read only.
                <PropertySaleSheetList
                    filter={filter}
                    isAuthenticated={isAuthenticated}
                    isLoading={false}
                    controlType="table2"
                    saveForm={saveForm}
                    user={user}
                    data={data}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    deleteRecord={deleteRecord}
                    salesheetid={salesheetid}
                    validateRelatedRecord={validateRelatedRecord}
                />
            </Modal.Body>
        </Modal>
    );
}
export default PropertySaleSheetModal;